import { CSSProperties } from "react";
import cssVars from "../../../styles/cssVariables.vars";

import { TableColumn } from "../types";
import PhoneInput from "react-phone-number-input";
import { CustomStateHook } from "../../../Hooks/State.hook";
import { FilterWithPaginationQueryParameters } from "../../../interfaces/generics.types";

function filterPhone<T>(
    column: TableColumn<T>,
    filterState: CustomStateHook<FilterWithPaginationQueryParameters<T>>,
    key: string | number
) {
    const onChange = (v?: string) => {
        filterState.set(prev => {
            if (v) {
                prev[column.key] = v as any;
            } else {
                delete prev[column.key]
            }

            return prev;
        })
    }

    const containerStyle: CSSProperties = {
        borderColor: cssVars.colorGrey[2],
        width: column.filter!.width,
        borderRadius: "0.5rem"
    }

    const inputStyle: CSSProperties = {
        fontSize: "1rem",
        color: cssVars.colorGrey[3],
        backgroundColor: cssVars.colorGrey[8],
        borderColor: cssVars.colorGrey[2],
        width: "100%",
        borderRadius: "0.5rem"
    }

    const buttonStyle: CSSProperties = {
        backgroundColor: cssVars.colorGrey[7],
        borderColor: cssVars.colorGrey[2],
        borderTopLeftRadius: "0.5rem",
        borderBottomLeftRadius: "0.5rem"
    }

    const dropdownStyle: CSSProperties = {
        backgroundColor: cssVars.colorGrey[7],
    }

    return (
        <PhoneInput
            country="br"
            containerClass="phone_input_container"
            dropdownClass="phone_input_dropdown"
            buttonClass="phone_input_button"
            onChange={onChange}
            containerStyle={containerStyle}
            inputStyle={inputStyle}
            buttonStyle={buttonStyle}
            dropdownStyle={dropdownStyle}
            key={key}
        />
    );
}

export default filterPhone;
